module.exports = __webpack_public_path__ + "static/media/wirebucklesfront.ec3c1267.png";